var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size * 1.33,
        height: _vm.size,
        viewBox: "0 0 32 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M5.65 3.5C11.8333 3.5 12.8167 3.5 19 3.5C24.2467 3.5 28.5 7.75329 28.5 13C28.5 18.2467 24.2467 22.5 19 22.5H15",
          stroke: _vm.color,
          "stroke-width": "1.3",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M2.64507 2.93557L4.75612 1.08839C5.24106 0.664074 6 1.00846 6 1.65283V5.34717C6 5.99154 5.24106 6.33593 4.75612 5.91161L2.64507 4.06443C2.30357 3.76562 2.30357 3.23438 2.64507 2.93557Z",
          fill: _vm.color
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M10.1245 15.62V17H15.4165V15.62H13.7605V9.044H12.2725L10.0765 9.944L10.4845 11.156L12.0445 10.52V15.62H10.1245ZM16.309 13.508C16.597 13.46 17.449 13.424 18.001 13.424C19.441 13.424 20.137 13.736 20.137 14.66C20.137 15.452 19.693 15.86 18.901 15.86C18.073 15.86 17.689 15.476 17.773 14.684H16.045C15.781 16.364 16.633 17.156 18.757 17.156C20.917 17.156 21.901 16.124 21.901 14.528C21.901 12.788 20.797 12.14 18.685 12.14C18.433 12.14 18.157 12.152 17.905 12.164L18.037 10.544H21.349L21.481 9.044H16.597L16.309 13.508Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }